export default __webpack_public_path__ + "static/media/auctionslogo3.a2859bef.png";